import { POST } from "../utils/constants";
import { fetchData } from "../utils/dataProvider";

export const sendMerchantInvitations = (emails: string[]) =>
  fetchData({
    url: "/marketplaces/send-invitation",
    method: POST,
    body: { emails },
  });
